/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { combineReducers } from 'redux';
import { uiReducer } from './ui.reducer';
import { authReducer } from './auth.reducer';
import { userReducer } from './user.reducer';
import { companiesReducer } from './companies.reducer';
import { settingsReducer } from './settings.reducer';

const rootReducer = combineReducers({
  //TODO: List Reducers Here
  ui: uiReducer,
  auth: authReducer,
  user: userReducer,
  companies: companiesReducer,
  settings: settingsReducer,
});
export default rootReducer;
